import React, { useRef } from "react";
import {
    CCard,
    CCardBody,
    CCardFooter,
    CCardTitle,
    CCol,
    CContainer,
    CFormInput,
    CFormLabel,
    CFormText,
    CRow,
    CTable,
    CTableBody,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
} from "@coreui/react";
import Table from "../../components/Table";
import { useDispatch, useSelector } from "react-redux";
import CustomerSearch from "../../components/SearchInputs/CustomerSearch";
import CreatedUserSearch from "../../components/SearchInputs/CreatedUserSearch";
import CreatedAtSearch from "../../components/SearchInputs/CreatedAtSearch";
import DateDisplay from "../../components/DisplayData/DateDisplay";
import Search from "../../components/SearchInputs/Search";
import { applyFilter } from "../../store/slice/component/table";
import PrintAccountStatmentLink from "../../components/PrintAccountStatmentLink";

const List = () => {
    const tableRef = useRef();
    const dispatch = useDispatch([]);
    const list = useSelector((state) => state.entities.component_table);
    return (
        <>
            <Table ref={tableRef}>
                <>
                    <CTable responsive={true}>
                        <CTableHead>
                            <CTableRow>
                                <CTableHeaderCell scope="col">
                                    ID
                                </CTableHeaderCell>
                                <CTableHeaderCell scope="col">
                                    By
                                </CTableHeaderCell>
                                <CTableHeaderCell scope="col">
                                    Customer
                                </CTableHeaderCell>
                                <CTableHeaderCell scope="col">
                                    Deposit
                                </CTableHeaderCell>
                                <CTableHeaderCell scope="col">
                                    Withdrawal
                                </CTableHeaderCell>
                                <CTableHeaderCell scope="col">
                                    Balance
                                </CTableHeaderCell>
                            </CTableRow>
                        </CTableHead>
                        <CTableBody>
                            {list.data !== undefined &&
                                list.data[0] === undefined && (
                                    <tr>
                                        <td colSpan={8}>
                                            Great! You are free of all entities.
                                        </td>
                                    </tr>
                                )}
                            {list.data &&
                                list.data.map((l) => {
                                    return (
                                        <CTableRow key={l.data.id}>
                                            <CTableHeaderCell scope="row">
                                                {l.data.id}
                                            </CTableHeaderCell>
                                            <CTableHeaderCell scope="row">
                                                <CRow>
                                                    <CCol>
                                                        {l.data.created_by.name}
                                                    </CCol>
                                                </CRow>
                                                <CRow>
                                                    <CCol>
                                                        @
                                                        <DateDisplay>
                                                            {l.data.created_at}
                                                        </DateDisplay>
                                                    </CCol>
                                                </CRow>
                                                {l?.data?.customer_ledger_memo
                                                    ?.percentage > 0 &&
                                                l?.data?.customer_ledger_memo
                                                    ?.percentage_amount > 0 ? (
                                                    <CRow>
                                                        <CCol>
                                                            Interest @{" "}
                                                            {
                                                                l.data
                                                                    .customer_ledger_memo
                                                                    .percentage
                                                            }{" "}
                                                            % is{" "}
                                                            {
                                                                l.data
                                                                    .customer_ledger_memo
                                                                    .percentage_amount
                                                            }{" "}
                                                            Amount
                                                        </CCol>
                                                    </CRow>
                                                ) : null}
                                            </CTableHeaderCell>
                                            <CTableHeaderCell scope="row">
                                                {l.data.customer_account.name} #
                                                {
                                                    l.data.customer_account
                                                        .customer_account_number
                                                }
                                                <PrintAccountStatmentLink
                                                    customer_account_number={
                                                        l.data.customer_account
                                                            .customer_account_number
                                                    }
                                                />
                                            </CTableHeaderCell>
                                            <CTableHeaderCell scope="row">
                                                {l.data.deposit}
                                            </CTableHeaderCell>
                                            <CTableHeaderCell scope="row">
                                                {l.data.withdrawal}
                                            </CTableHeaderCell>
                                            <CTableHeaderCell scope="row">
                                                {l.data.current_balance}
                                            </CTableHeaderCell>
                                        </CTableRow>
                                    );
                                })}
                        </CTableBody>
                    </CTable>
                </>
            </Table>
            <CContainer fluid={true} className={"pt-3"}>
                <CCard>
                    <CCardBody>
                        <CCardTitle>Search/Filter Listing</CCardTitle>
                        <CRow>
                            <CCol lg={6}>
                                <CustomerSearch />
                            </CCol>
                            <CCol>
                                <CreatedUserSearch />
                            </CCol>
                            <CCol>
                                <CreatedAtSearch />
                            </CCol>
                        </CRow>
                        <CRow className={"mt-3"}>
                            <CCol md={4}>
                                <CFormLabel>Deposit</CFormLabel>
                                <CFormInput
                                    type="text"
                                    onChange={(e) => {
                                        dispatch(
                                            applyFilter({
                                                field_name: "deposit",
                                                value: e.target.value,
                                            })
                                        );
                                    }}
                                    defaultValue={list.deposit || ""}
                                />
                                <CFormText>Example: 50, 422, 300</CFormText>
                            </CCol>
                            <CCol md={4}>
                                <CFormLabel>Withdrawal</CFormLabel>
                                <CFormInput
                                    type="text"
                                    onChange={(e) => {
                                        dispatch(
                                            applyFilter({
                                                field_name: "withdrawal",
                                                value: e.target.value,
                                            })
                                        );
                                    }}
                                    defaultValue={list.withdrawal || ""}
                                />
                                <CFormText>Example: 50, 422, 300</CFormText>
                            </CCol>
                            <CCol md={4}>
                                <CFormLabel>Balance</CFormLabel>
                                <CFormInput
                                    type="text"
                                    onChange={(e) => {
                                        dispatch(
                                            applyFilter({
                                                field_name: "balance",
                                                value: e.target.value,
                                            })
                                        );
                                    }}
                                    defaultValue={list.balance || ""}
                                />
                                <CFormText>Example: 50, 422, 300</CFormText>
                            </CCol>
                        </CRow>
                    </CCardBody>
                    <CCardFooter>
                        <Search
                            onSearch={() => {
                                tableRef.current.callFromSubmitted(list);
                            }}
                        />
                    </CCardFooter>
                </CCard>
            </CContainer>
        </>
    );
};

export default List;
